import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

interface ErrorPageProps {
  error?: Error | null;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ error }) => {
  const location = useLocation();
  const locationError = location.state?.error;

  const erroFinal = error || locationError;

  const tituloErro = erroFinal?.name || 'Erro Inesperado';
  const mensagemAmigavel = erroFinal?.message || 'Parece que algo não saiu como o esperado. Por favor, tente novamente mais tarde ou entre em contato com o suporte.';
  const detalhesErro = erroFinal?.stack;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-background text-text flex flex-col items-center justify-center p-4 sm:p-8"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="text-center max-w-lg w-full p-8 rounded-lg shadow-2xl border border-danger/30"
      >
        <h1 className="text-7xl sm:text-8xl font-extrabold text-danger mb-4 drop-shadow-lg">
          Oops!
        </h1>
        <h2 className="text-3xl sm:text-4xl font-bold text-text mb-4">
          {tituloErro}
        </h2>
        <p className="text-lg text-gray-300 mb-8 leading-relaxed">
          {mensagemAmigavel}
        </p>

        {detalhesErro && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="bg-gray-700 p-4 rounded-md text-sm text-gray-400 text-left overflow-auto max-h-48 mb-8"
          >
            <p className="font-semibold text-accent mb-2">Detalhes Técnicos:</p>
            <pre className="whitespace-pre-wrap break-words">
              {detalhesErro}
            </pre>
          </motion.div>
        )}

        <Link to="/" className="inline-block">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="px-8 py-3 bg-primary text-background font-semibold rounded-lg shadow-md hover:bg-gradient-to-r from-[#c5a663] via-[#f2dd82] to-[#c5a663] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
          >
            Voltar para o Início
          </motion.button>
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default ErrorPage;